import React, { Component } from 'react';
import Home from './containers/Home/Home';
import 'bootstrap/dist/js/bootstrap';
import './scss/custom.scss';
import { Provider } from 'react-redux';
import combinedStore from './CombinedStore';
import { createGA } from './utilities/GAHelpers/GAHelpers';
import Interceptor from './services/interceptor';
import Hotjar from './utilities/Hotjar/Hotjar';

Interceptor.interceptor(combinedStore);

class App extends Component {
  componentDidMount = () => {
    createGA();
  };

  render() {
    return (
      <Provider store={combinedStore}>
        <Hotjar />
        <Home />
      </Provider>
    );
  }
}

export default App;
